export default __webpack_public_path__ + "static/media/paninoTtsIt_It60.ffad12b6.mp3";